<div class="align-self-center">
  <div class="row justify-content-md-center">
    <div class="col-lg-3 col-md-4 col-sm-12">
      <ng-content></ng-content>
      <vault-footer class="text-center"></vault-footer>
    </div>
  </div>
</div>
